import { NamirasoftAccessServer } from "namirasoft-access";
import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NSNotFoundPage } from "namirasoft-site-react";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { AccessLayout } from "./AccessLayout";
import { AccessRoutes } from "./AccessRoutes";
import HomePage from "./pages/HomePage";
import IncomingPermissionListPage from "./pages/IncomingPermissionListPage";
import IncomingPermissionViewPage from "./pages/IncomingPermissionViewPage";
import LoginPage from "./pages/LoginPage";
import OutgoingPermissionEditPage from "./pages/OutgoingPermissionEditPage";
import OutgoingPermissionListPage from "./pages/OutgoingPermissionListPage";
import OutgoingPermissionViewPage from "./pages/OutgoingPermissionViewPage";
import PermissionViewDecisionPage from "./pages/PermissionViewDecisionPage";
import PolicyEditPage from "./pages/PolicyEditPage";
import PolicyListPage from "./pages/PolicyListPage";
import PolicyViewPage from "./pages/PolicyViewPage";
import RoleEditPage from "./pages/RoleEditPage";
import RoleListPage from "./pages/RoleListPage";
import RoleViewPage from "./pages/RoleViewPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_ACCESS}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_ACCESS = new EnvService("REACT_APP_BASE_URL_ACCESS", true).getString();
            let access = new NamirasoftAccessServer(REACT_APP_BASE_URL_ACCESS, result.account.token_manager, result.notifier.onError);
            let servers = { access };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows => (<Routes>
                        <Route path={AccessRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                        <Route path={AccessRoutes.PermissionView(":id")} element={<PermissionViewDecisionPage {...result} servers={servers} />} />

                        <Route path={AccessRoutes.OutgoingPermissionList} element={<OutgoingPermissionListPage {...result} servers={servers} />} />
                        <Route path={AccessRoutes.OutgoingPermissionNew} element={<OutgoingPermissionEditPage {...result} servers={servers} isEdit={false} />} />
                        <Route path={AccessRoutes.OutgoingPermissionCopy(":id")} element={<OutgoingPermissionEditPage {...result} servers={servers} isEdit={false} />} />
                        <Route path={AccessRoutes.OutgoingPermissionEdit(":id")} element={<OutgoingPermissionEditPage {...result} servers={servers} isEdit={true} />} />
                        <Route path={AccessRoutes.OutgoingPermissionView(":id")} element={<OutgoingPermissionViewPage {...result} servers={servers} />} />

                        <Route path={AccessRoutes.IncomingPermissionList} element={<IncomingPermissionListPage {...result} servers={servers} />} />
                        <Route path={AccessRoutes.IncomingPermissionView(":id")} element={<IncomingPermissionViewPage {...result} servers={servers} />} />

                        <Route path={AccessRoutes.PolicyList} element={<PolicyListPage {...result} servers={servers} />} />
                        <Route path={AccessRoutes.PolicyNew} element={<PolicyEditPage {...result} servers={servers} isEdit={false} />} />
                        <Route path={AccessRoutes.PolicyCopy(":id")} element={<PolicyEditPage {...result} servers={servers} isEdit={false} />} />
                        <Route path={AccessRoutes.PolicyEdit(":id")} element={<PolicyEditPage {...result} servers={servers} isEdit={true} />} />
                        <Route path={AccessRoutes.PolicyView(":id")} element={<PolicyViewPage {...result} servers={servers} />} />

                        <Route path={AccessRoutes.RoleList} element={<RoleListPage {...result} servers={servers} />} />
                        <Route path={AccessRoutes.RoleNew} element={<RoleEditPage {...result} servers={servers} isEdit={false} />} />
                        <Route path={AccessRoutes.RoleCopy(":id")} element={<RoleEditPage {...result} servers={servers} isEdit={false} />} />
                        <Route path={AccessRoutes.RoleEdit(":id")} element={<RoleEditPage {...result} servers={servers} isEdit={true} />} />
                        <Route path={AccessRoutes.RoleView(":id")} element={<RoleViewPage {...result} servers={servers} />} />

                        {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                        <Route path="*" element={<NSNotFoundPage />} />
                    </Routes >))}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={AccessRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <AccessLayout
                {...props}
            >
                {props.children}
            </AccessLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: false
            }
        }}
    />
}

export default Router;